import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#050505] border-t border-gray-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-6">
          <p className="text-gray-400 text-lg">
            Building for the London Indie Scene.
          </p>
          
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <a
              href="/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#4ADE80] transition-colors duration-200"
            >
              Privacy Policy
            </a>
            <span className="text-gray-600">•</span>
            <a
              href="/terms.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#4ADE80] transition-colors duration-200"
            >
              Terms of Service
            </a>
            <span className="text-gray-600">•</span>
            <Link
              to="/contact"
              className="text-gray-400 hover:text-[#4ADE80] transition-colors duration-200"
            >
              Contact Support
            </Link>
          </div>
          
          <div className="pt-6 border-t border-gray-800">
            <p className="text-gray-500 text-sm">
              © 2026 CrowdOne. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
